import {
  soapAuthKindFromTagMode,
  soapAuthUsesPassword,
  type SoapAuthKind
} from '@atbash-labs/ontology-core'

import type { PrepValues } from './types'

export { soapAuthKindFromTagMode, soapAuthUsesPassword }

export function soapAuthFields(prep: PrepValues | undefined): {
  authKind: SoapAuthKind
  username?: string
  password?: string
} {
  const authKind = soapAuthKindFromTagMode(prep?.tagMode)
  if (!soapAuthUsesPassword(authKind)) return { authKind }
  const username = prep?.fields.username?.trim() ?? ''
  return {
    authKind,
    ...(username ? { username } : {}),
    ...(prep?.fields.password !== undefined ? { password: prep.fields.password } : {})
  }
}
